module.exports = __webpack_public_path__ + "static/media/importICloud1.136f957d.png";